<div class="d-flex justify-content-center m">
  <div class="card">
    <div class="card-header text-center">
      <h4 class="display-5">Send Email To Students</h4>
    </div>
    <form #uploadform="ngForm" name="uploadform" class="ml-5 mr-5 mt-1">
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="sbw_light">Mail Subject: *</label>
          <input class="form-control" type="text" placeholder="Subject" aria-label="Subject" [(ngModel)]="mailSubject"
            [ngModelOptions]="{standalone: true}">
        </div>

        <div class="col-md-6">
          <label class="sbw_light">Course: </label>
          <select class="form-select form-control" [(ngModel)]="selectedId" [ngModelOptions]="{standalone: true}"
            (change)="onModuleSelected($event.target.value)" required [disabled]="isreadonly">
            <option selected disabled>Select Course</option>
            <option value="0">All Students</option>
            <option *ngFor="let module of modules" [value]="module.id">{{module.moduleName}}</option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6" *ngIf="selectedCode">
          <label class="sbw_light">Code:</label>
          <input class="form-control" type="text" readonly [(ngModel)]="selectedCode"
            [ngModelOptions]="{standalone: true}">
        </div>
      </div>
      <div>
        <p class="text-muted fs-6 fw-lighter"><small>Placeholders: {{placeholder}}</small></p>
      </div>
      <quill-editor placeholder="Enter Message Body" classes="ql-container--lg" required [(ngModel)]="mailBody"
        [ngModelOptions]="{standalone: true}"></quill-editor>
      <div class="card-footer">
        <div class="d-flex justify-content-around">
          <button type="submit" class="btn btn--warning m-0" (click)="testMail()"
            [disabled]="disableButtons">Test</button>
          <button type="submit" class="btn m-0" [disabled]="disableButtons" (click)="sendMail()">Send</button>
        </div>
      </div>
    </form>
  </div>
</div>
